import { Route } from '@angular/router';
import { roleGuard } from '../core/services/guards';
import { RoleType } from '../core/types/role.type';

export const pageRoutes: Route[] = [
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard').then(m => m.DashboardPage),
    canActivate: [roleGuard],
    data: {
      roles: [RoleType.Admin, RoleType.Superadmin],
    },
  },
  {
    path: 'map',
    loadComponent: () => import('./parking-map').then(m => m.ParkingMapComponent),
    canActivate: [roleGuard],
    data: {
      roles: [RoleType.Admin, RoleType.Superadmin],
    },
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings').then(route => route.settingsRoutes),
    canActivate: [roleGuard],
    data: {
      roles: [RoleType.Admin, RoleType.Superadmin],
    },
  },
  {
    path: 'operator-parking',
    loadComponent: () => import('./operator-parking').then(m => m.OperatorParkingPage),
    canActivate: [roleGuard],
    data: {
      roles: [RoleType.Operator, RoleType.Superadmin],
    },
  },
  {
    path: 'operator-parking-events',
    loadComponent: () => import('./operator-parking-events').then(m => m.OperatorParkingEventsPage),
    canActivate: [roleGuard],
    data: {
      roles: [RoleType.Operator, RoleType.Superadmin],
    },
  },
  {
    path: 'access-denied',
    loadComponent: () => import('@shared/pages').then(m => m.AccessDeniedPage),
    pathMatch: 'full',
  },
  {
    path: 'not-found',
    loadComponent: () => import('@shared/pages').then(m => m.NotFoundPage),
    pathMatch: 'full',
  },
  // {
  //   path: '**',
  //   redirectTo: 'not-found',
  //   pathMatch: 'full',
  // },
];
